/* eslint-disable @typescript-eslint/no-explicit-any */
import useInteractions from '@/scenes/DynamicHome/hooks/useInteractions'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import { useHydratedSSR } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { useRouter } from 'next/navigation'

const SearchLogic = ({
  Wrapper,
  filtersIcons,
  onRouterChange,
  isMobile,
}: any) => {
  const { hasProducts, loading, promoted, carousels } = useFiltersContext()
  const clientConfig = UseClientModelContext()
  const router = useRouter()
  const hydratedSSR = useHydratedSSR()

  const widgetInteractionLogic = useInteractions({
    clientConfig,
    router,
  })

  return (
    <Wrapper
      loading={loading || !hydratedSSR}
      hasProducts={hasProducts}
      isMobile={isMobile}
      promoted={promoted}
      filtersIcons={filtersIcons}
      clientConfig={clientConfig}
      goToPath={onRouterChange}
      carousels={carousels}
      widgetInteractionLogic={widgetInteractionLogic}
    />
  )
}

export default SearchLogic
